import {Component} from '@angular/core';

@Component({
    selector: 'ui-spinner',
    styleUrls: ['spinner.component.scss'],
    template: '<div></div><div></div><div></div>'
})
export class UISpinnerComponent {
}